import {Injectable} from '@angular/core';
import {ApiProvider} from '../api/api';
import {WorkTable} from '../../models/work_table';
import {WorkTableEntry} from '../../models/work_table_entry';


@Injectable()
export class ScheduleProvider {

    private data: Array<WorkTable>;

    constructor(public api: ApiProvider) {
        this.data = new Array<WorkTable>();
        let workTime = new Array<WorkTableEntry>();
        workTime.push(new WorkTableEntry("2018-03-02", "10:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-06", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-07", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-08", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-09", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-10", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-11", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-13", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-14", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-15", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-16", "09:00", "17:00"));
        let workTable = new WorkTable('3333333333', workTime);
        this.data.push(workTable);
        workTime = new Array<WorkTableEntry>();
        workTime.push(new WorkTableEntry("2018-03-07", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-02", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-08", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-09", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-10", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-11", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-12", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-13", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-14", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-15", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-16", "09:00", "17:00"));
        workTable = new WorkTable('4444444444', workTime);
        this.data.push(workTable);
        workTime = new Array<WorkTableEntry>();
        workTime.push(new WorkTableEntry("2018-03-01", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-02", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-08", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-09", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-10", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-11", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-12", "16:00", "19:00"));
        workTime.push(new WorkTableEntry("2018-03-13", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-14", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-15", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-16", "09:00", "17:00"));
        workTable = new WorkTable('6666666666', workTime);
        this.data.push(workTable);
        workTime = new Array<WorkTableEntry>();
        workTime.push(new WorkTableEntry("2018-03-07", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-02", "08:00", "16:00"));
        workTime.push(new WorkTableEntry("2018-03-08", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-09", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-10", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-11", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-12", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-13", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-14", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-15", "09:00", "17:00"));
        workTime.push(new WorkTableEntry("2018-03-16", "09:00", "17:00"));
        workTable = new WorkTable('2222222222', workTime);
        this.data.push(workTable);
    }
}



// WEBPACK FOOTER //
// ./src/providers/schedule/schedule.ts